import {
  getAll,
  searchByName,
  getPage,
  getDetail,
  getClientPage,
  getMyUserGroupPage,
  exportExcel,
  addProcessRemark,
  batchAddProcessRemark,
  analyzeSingle,
  getTeamReport
} from '@/api/vehicleofflineanalysisresultserv'

export default {
  state: {
    state_VehicleOfflineAnalysisResult_GetAllResult: null,
    state_VehicleOfflineAnalysisResult_SearchByNameResult: null,
    state_VehicleOfflineAnalysisResult_GetPageResult: null,
    state_VehicleOfflineAnalysisResult_GetDetailResult: null,
    state_VehicleOfflineAnalysisResult_GetClientPageResult: null,
    state_VehicleOfflineAnalysisResult_GetMyUserGroupPageResult: null,
    state_VehicleOfflineAnalysisResult_ExportExcelResult: null,
    state_VehicleOfflineAnalysisResult_AddProcessRemarkResult: null,
    state_VehicleOfflineAnalysisResult_BatchAddProcessRemarkResult: null,
    state_VehicleOfflineAnalysisResult_AnalyzeSingleResult: null,
    state_VehicleOfflineAnalysisResult_GetTeamReportResult: null
  },
  mutations: {
    SET_VEHICLEOFFLINEANALYSISRESULT_GETALL_RESULT: (state, rst) => {
      state.state_VehicleOfflineAnalysisResult_GetAllResult = rst
    },
    SET_VEHICLEOFFLINEANALYSISRESULT_SEARCHBYNAME_RESULT: (state, rst) => {
      state.state_VehicleOfflineAnalysisResult_SearchByNameResult = rst
    },
    SET_VEHICLEOFFLINEANALYSISRESULT_GETPAGE_RESULT: (state, rst) => {
      state.state_VehicleOfflineAnalysisResult_GetPageResult = rst
    },
    SET_VEHICLEOFFLINEANALYSISRESULT_GETDETAIL_RESULT: (state, rst) => {
      state.state_VehicleOfflineAnalysisResult_GetDetailResult = rst
    },
    SET_VEHICLEOFFLINEANALYSISRESULT_GETCLIENTPAGE_RESULT: (state, rst) => {
      state.state_VehicleOfflineAnalysisResult_GetClientPageResult = rst
    },
    SET_VEHICLEOFFLINEANALYSISRESULT_GETMYUSERGROUPPAGE_RESULT: (state, rst) => {
      state.state_VehicleOfflineAnalysisResult_GetMyUserGroupPageResult = rst
    },
    SET_VEHICLEOFFLINEANALYSISRESULT_EXPORTEXCEL_RESULT: (state, rst) => {
      state.state_VehicleOfflineAnalysisResult_ExportExcelResult = rst
    },
    SET_VEHICLEOFFLINEANALYSISRESULT_ADDPROCESSREMARK_RESULT: (state, rst) => {
      state.state_VehicleOfflineAnalysisResult_AddProcessRemarkResult = rst
    },
    SET_VEHICLEOFFLINEANALYSISRESULT_BATCHADDPROCESSREMARK_RESULT: (state, rst) => {
      state.state_VehicleOfflineAnalysisResult_BatchAddProcessRemarkResult = rst
    },
    SET_VEHICLEOFFLINEANALYSISRESULT_ANALYZESINGLE_RESULT: (state, rst) => {
      state.state_VehicleOfflineAnalysisResult_AnalyzeSingleResult = rst
    },
    SET_VEHICLEOFFLINEANALYSISRESULT_GETTEAMREPORT_RESULT: (state, rst) => {
      state.state_VehicleOfflineAnalysisResult_GetTeamReportResult = rst
    }
  },
  actions: {
    VehicleOfflineAnalysisResultServ_GetAll ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEOFFLINEANALYSISRESULT_GETALL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEOFFLINEANALYSISRESULT_GETALL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleOfflineAnalysisResultServ_SearchByName ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        searchByName(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEOFFLINEANALYSISRESULT_SEARCHBYNAME_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEOFFLINEANALYSISRESULT_SEARCHBYNAME_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleOfflineAnalysisResultServ_GetPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEOFFLINEANALYSISRESULT_GETPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEOFFLINEANALYSISRESULT_GETPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleOfflineAnalysisResultServ_GetDetail ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEOFFLINEANALYSISRESULT_GETDETAIL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEOFFLINEANALYSISRESULT_GETDETAIL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleOfflineAnalysisResultServ_GetClientPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getClientPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEOFFLINEANALYSISRESULT_GETCLIENTPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEOFFLINEANALYSISRESULT_GETCLIENTPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleOfflineAnalysisResultServ_GetMyUserGroupPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getMyUserGroupPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEOFFLINEANALYSISRESULT_GETMYUSERGROUPPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEOFFLINEANALYSISRESULT_GETMYUSERGROUPPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleOfflineAnalysisResultServ_ExportExcel ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        exportExcel(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEOFFLINEANALYSISRESULT_EXPORTEXCEL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEOFFLINEANALYSISRESULT_EXPORTEXCEL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleOfflineAnalysisResultServ_AddProcessRemark ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        addProcessRemark(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEOFFLINEANALYSISRESULT_ADDPROCESSREMARK_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEOFFLINEANALYSISRESULT_ADDPROCESSREMARK_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleOfflineAnalysisResultServ_BatchAddProcessRemark ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        batchAddProcessRemark(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEOFFLINEANALYSISRESULT_BATCHADDPROCESSREMARK_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEOFFLINEANALYSISRESULT_BATCHADDPROCESSREMARK_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleOfflineAnalysisResultServ_AnalyzeSingle ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        analyzeSingle(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEOFFLINEANALYSISRESULT_ANALYZESINGLE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEOFFLINEANALYSISRESULT_ANALYZESINGLE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    VehicleOfflineAnalysisResultServ_GetTeamReport ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getTeamReport(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_VEHICLEOFFLINEANALYSISRESULT_GETTEAMREPORT_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_VEHICLEOFFLINEANALYSISRESULT_GETTEAMREPORT_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  getters: {
    get_VehicleOfflineAnalysisResult_GetAllResult: state => {
      return state.state_VehicleOfflineAnalysisResult_GetAllResult
    },
    get_VehicleOfflineAnalysisResult_SearchByNameResult: state => {
      return state.state_VehicleOfflineAnalysisResult_SearchByNameResult
    },
    get_VehicleOfflineAnalysisResult_GetPageResult: state => {
      return state.state_VehicleOfflineAnalysisResult_GetPageResult
    },
    get_VehicleOfflineAnalysisResult_GetDetailResult: state => {
      return state.state_VehicleOfflineAnalysisResult_GetDetailResult
    },
    get_VehicleOfflineAnalysisResult_GetClientPageResult: state => {
      return state.state_VehicleOfflineAnalysisResult_GetClientPageResult
    },
    get_VehicleOfflineAnalysisResult_GetMyUserGroupPageResult: state => {
      return state.state_VehicleOfflineAnalysisResult_GetMyUserGroupPageResult
    },
    get_VehicleOfflineAnalysisResult_ExportExcelResult: state => {
      return state.state_VehicleOfflineAnalysisResult_ExportExcelResult
    },
    get_VehicleOfflineAnalysisResult_AddProcessRemarkResult: state => {
      return state.state_VehicleOfflineAnalysisResult_AddProcessRemarkResult
    },
    get_VehicleOfflineAnalysisResult_BatchAddProcessRemarkResult: state => {
      return state.state_VehicleOfflineAnalysisResult_BatchAddProcessRemarkResult
    },
    get_VehicleOfflineAnalysisResult_AnalyzeSingleResult: state => {
      return state.state_VehicleOfflineAnalysisResult_AnalyzeSingleResult
    },
    get_VehicleOfflineAnalysisResult_GetTeamReportResult: state => {
      return state.state_VehicleOfflineAnalysisResult_GetTeamReportResult
    }
  }
}
